import React from 'react'
import CustomerPortalContainer from '../../../containers/customer_portal/layout'

const CustomerPortalPage = () => {
  return <CustomerPortalContainer/>
}

export default CustomerPortalPage;